// 以年开头的时间格式
export const COMMON_TIME_FORMAT_END_M = 'YYYY/MM';

export const COMMON_TIME_FORMAT_END_D = 'YYYY/MM/DD';
// autocorrect: false
export const COMMON_TIME_FORMAT_END_ZH = 'YYYY年MM月DD日';
export const COMMON_TIME_FORMAT_END_D_EN = 'MMM D YYYY';
export const COMMON_TIME_FORMAT_END_D_SINGLE_M = 'YYYY/M/DD';
export const COMMON_TIME_FORMAT_END_D_SINGLE_MD = 'YYYY/M/D';

export const COMMON_TIME_FORMAT_END_0 = 'YYYY/MM/DD 00:00:00';

export const COMMON_TIME_FORMAT_END_m = 'YYYY/MM/DD HH:mm';
export const COMMON_TIME_FORMAT_END_m_EN = 'MMM D YYYY,H:mm';
export const COMMON_TIME_FORMAT_END_m0 = 'YYYY/MM/DD HH:mm:00';
export const COMMON_TIME_FORMAT_END_m_SINGLE_MDH = 'YYYY/M/D H:mm';

export const COMMON_TIME_FORMAT_END_s = 'YYYY/MM/DD HH:mm:ss';

// 以 - 分割
export const HYPHENATED_TIME_FORMAT_END_M = 'YYYY-MM';

export const HYPHENATED_TIME_FORMAT_END_D = 'YYYY-MM-DD';

export const HYPHENATED_TIME_FORMAT_END_0 = 'YYYY-MM-DD 00:00:00';

export const HYPHENATED_TIME_FORMAT_END_m0 = 'YYYY-MM-DD HH:mm:00';
export const HYPHENATED_TIME_FORMAT_END_m = 'YYYY-MM-DD HH:mm';

export const HYPHENATED_TIME_FORMAT_END_s = 'YYYY-MM-DD HH:mm:ss';

// 以 . 分割
export const DOT_TIME_FORMAT_END_D = 'YYYY.MM.DD';

// 以月份开头的时间格式
// autocorrect: false
export const MONTH_TIME_FORMAT_MMDD_ZH = 'MM月DD日';
// autocorrect: false
export const MONTH_TIME_FORMAT_MDHmm_ZH = 'M月D日 H:mm';
export const MONTH_TIME_FORMAT_MMMDHmm_EN = 'MMM D,H:mm';

// 以小时开头的时间格式
export const COMMON_TIME_FORMAT_HHmm = 'HH:mm';

export const COMMON_TIME_FORMAT_HHmmss = 'HH:mm:ss';
